import type { ThreadSettings } from "../../../api/threads/liveMessages";
import type { TurnRoute } from "../hosting/routeChoices";

/**
 * The Thread's settings with an agent step's own route (F106): the settings stay the one
 * owner of which LLM a step runs on (`step_routes`, read by the turn runner). `null` takes
 * the step's own choice off, so it runs on the Thread's default again.
 */
export function settingsWithStepRoute(settings: ThreadSettings, stepKey: string, route: TurnRoute | null): ThreadSettings {
  return { ...settings, step_routes: withStepRoute(settings.step_routes, stepKey, route) };
}

/** Agent steps' own routes with `stepKey`'s set, or taken off with `null`: the one edit rule for a Thread's settings and a start's draft. */
export function withStepRoute(stepRoutes: Readonly<Record<string, TurnRoute>>, stepKey: string, route: TurnRoute | null): Record<string, TurnRoute> {
  const { [stepKey]: _replaced, ...others } = stepRoutes;
  return route === null ? others : { ...others, [stepKey]: route };
}

/** How many steps run on a route of their own, not the Thread's default. */
export function stepsWithOwnRoute(settings: ThreadSettings): number {
  return Object.keys(settings.step_routes).length;
}
